import { Component, ViewChild } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';
import { NumberCardsService } from '../number-cards.service';
import { MessageService } from '../../shared/message.service';
import { NgModel, NgForm } from '@angular/forms';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['../topic-style.css', './playground.component.css']
})
export class PlaygroundComponent extends GeneralComponent {

  @ViewChild('definitionForm', {static:true}) public definitionForm: NgForm;

  exerciseType: string = undefined;
  solved = false;

  //used for all exercises
  representation: string;
  representationSpec: any = undefined;
  helptext: string = "symbols";
  cards: number[] = [];

  requestedNumber: number;
  protected showHelptext: Boolean = true;
  protected showSymbols: Boolean = true;
  protected count: number[] = [];
  protected solution: number[] = [];
  feedback: string;
  error: number[] = [];

  //used for the reduction
  private value: number = 0;
  private buckets: number[] = [];
  private size: number[] = [];
  useBuckets: boolean = true;

  //use for the position representation
  showComputation: boolean = true;

  //used for the addition exercise
  givenNumbers: number[] = [];
  length: number = undefined;
  isMultiplication: boolean = false;;
  countB: number[] = [];

  private solutionA: number[];
  private solutionB: number[];

  added: boolean = false;

  private errorb: number[] = [];

  constructor(protected topicService: TopicService, protected numberCardsService: NumberCardsService, protected messageService: MessageService) {
    super(topicService);
  }

  //resets all properties when changing the exercise type
  reset() {
    this.representation = undefined;
    this.cards = [];
    this.requestedNumber = undefined;
    this.value = 0;
    this.buckets = [];
    this.size = [];
    this.count = [];
    this.solution = [];
    this.feedback = "";
    this.error = [];
    this.givenNumbers = [];
    this.length = undefined;
    this.countB = [];

    this.solutionA = undefined;
    this.solutionB = undefined;

    this.added = false;

    this.errorb = [];

    this.solved = false;
  }

  //resets some of the properties to start a new exercise
  smallReset() {
    this.requestedNumber = undefined;
    this.value = 0;
    this.buckets = this.numberCardsService.getCount(this.cards);
    this.count = this.numberCardsService.getCount(this.cards);
    this.solution = [];
    this.feedback = "";
    this.error = [];
    this.givenNumbers = [];
    this.length = undefined;
    this.countB = this.numberCardsService.getCount(this.cards);

    this.solutionA = undefined;
    this.solutionB = undefined;

    this.added = false;

    this.errorb = [];

    this.solved = false;
  }

  /** computes and sets the cards */
  onChangeRepr() {
    if (!this.representationDefined()) {
      return;
    }
    let reprSpec = this.representationSpec;
    if (this.representation == "personal") {
      reprSpec = this.representationSpec.split(",");
    }
    this.cards = this.numberCardsService.getCards(this.representation, reprSpec);
    this.buckets = this.numberCardsService.getCount(this.cards);
    this.count = this.numberCardsService.getCount(this.cards);
    this.countB = this.numberCardsService.getCount(this.cards);
    let oldCard = null;
    for (let card of this.cards) {
      if (oldCard != null) {
        this.size[card] = oldCard / card;
      }
      oldCard = card;
    }
    this.count = this.numberCardsService.getCount(this.cards);
    if (this.requestedNumber) {
      this.solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
    }
  }

  /** sets the solution correctly  */
  onChangeRequestedNumber() {
    if (this.representationDefined()) {
      this.solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
    }
  }

  /** checks, whether everything for the representation is defined */
  representationDefined(): boolean {
    if (this.representation == "" || this.representation == null || this.representation == undefined) {
      return false;
    }
    if (this.representation == "nary" || this.representation == "personal") {
      if (this.representationSpec == undefined || this.representationSpec == null || this.representationSpec < 1) {
        return false;
      }
    }
    if (this.representation == "personal") {
      if (!this.numberCardsService.checkValidCards(this.representationSpec)) {
        return false;
      }
    }
    return true;
  }


  /** adds a card of the given value 
   * @param {number} card - value of card to add
  */
  addedCard(card: number): void {
    this.count[card]++;
  }

  /** removes a card of the given value 
   * @param {number} card - value of card to remove
  */
  removeCard(card: number): void {
    this.count[card]--;
  }

  /** generate the exercise automatically */
  generate() {
    this.smallReset();
    let representationId = Math.floor(Math.random() * 4);
    switch (representationId) {
      case 0:
        this.representation = "nary";
        this.representationSpec = Math.floor(Math.random() * 8 + 2);
        break;
      case 1:
        this.representation = "hexadecimal";
        break;
      case 2:
        this.representation = "roman";
        break;
      case 3:
        this.representation = "etruscan";
        break;
    }

    this.onChangeRepr();
    if (this.exerciseType == 'numberCard' || this.exerciseType == 'position') {
      this.requestedNumber = Math.floor(Math.random() * this.maxNumber());
      this.onChangeRequestedNumber();
    }
    if (this.exerciseType == 'reduction') {
      let value = 0;
      for(let card of this.cards){
        this.count[card] = Math.floor(Math.random() * Math.max(0,Math.min(((this.maxNumber() - value)/card - 2), 20)));
        value = this.numberCardsService.getValue(this.count);
      }
      this.solution = this.numberCardsService.getSolution(this.numberCardsService.getValue(this.count), this.cards);

    }
    if (this.exerciseType == 'addition') {
      let operationID = Math.floor(Math.random() * 2);
    switch (operationID) {
      case 0:
      this.isMultiplication =  false;
        this.givenNumbers[0] = Math.floor(Math.random() * this.maxNumber()/2);
        this.givenNumbers[1] = Math.floor(Math.random() * this.maxNumber()/2);
        break;
      case 1:
        this.isMultiplication = true;
        this.length = Math.floor(Math.random() * 4) + 2;
        this.givenNumbers[0] = Math.ceil(Math.random() * this.maxNumber() / this.length);
    }
      this.count = this.numberCardsService.getCount(this.cards);
      this.countB = this.numberCardsService.getCount(this.cards);
      this.solutionA = this.numberCardsService.getSolution(this.givenNumbers[0], this.cards);
      if (!this.isMultiplication) {
        this.solutionB = this.numberCardsService.getSolution(this.givenNumbers[1], this.cards);
      }
      let sum = 0;
      for (let number of this.givenNumbers) {
        sum += number;
      }
      this.solution = this.numberCardsService.getSolution(sum, this.cards);
      let index = 0;
      let oldCard = null;
      for (let card of this.cards) {
        if (oldCard != null) {
          this.size[card] = oldCard / card;
        }
        oldCard = card;
      }
    }
  }

  /** checks, whether the solution is correct or not and gives some feedback */
  checkSolution(): void {
    let error = false;
    this.error = [];
    this.feedback = "";
    if (this.exerciseType == 'numberCard' || this.exerciseType == 'position') {
      let value = this.numberCardsService.getValue(this.count);
      if (value != this.numberCardsService.getValue(this.solution) && this.showHelptext) {
        this.feedback = this.get("hasValue").concat(value.toString(), ". ");
      }
      for (let i = 0; i < this.cards.length; i++) {
        if (this.solution[i] != this.count[this.cards[i]]) {
          error = true;
          if (this.showSymbols) {
            this.error.push(this.cards[i]);
          }
          if (this.showHelptext) {
            if (this.solution[i] > this.count[this.cards[i]]) {
              this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
            } else {
              this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
            }
          }
        }
      }
      if (error) {
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
      } else {
        this.solved = true;
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      }
    }
    if (this.exerciseType == 'reduction') {
      let error = false;
      this.error = [];
      this.feedback = "";
      for (let card of this.cards) {
        if ((this.buckets[card] != 0 && this.buckets[card] != undefined)) {
          error = true;
        }
      }
      if (error) {
        this.feedback = this.feedback.concat(this.get("errorNonEmptyBucket"), "\n");
      }
      for (let i = 0; i < this.cards.length; i++) {
        if (this.solution[i] != this.count[this.cards[i]]) {
          error = true;
          if (this.showSymbols) {
            this.error.push(this.cards[i]);
          }
          if (this.showHelptext) {
            if (this.solution[i] > this.count[this.cards[i]]) {
              this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
            } else {
              this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
            }
          }
        }
      }
      if (error) {
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);

      } else {
        this.solved = true;
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      }

    }
    if (this.exerciseType == 'addition') {
      let error = false;
      this.error = [];
      this.feedback = "";
      if (!this.added) {
        this.feedback = this.get("addFirst");
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
        return;
      }
      let value = this.numberCardsService.getValue(this.count)
      if (value != this.numberCardsService.getValue(this.solution) && this.showHelptext) {
        this.feedback = this.get("hasValue").concat(value.toString(), ". ");
      }
      for (let i = 0; i < this.cards.length; i++) {
        if (this.solution[i] != this.count[this.cards[i]]) {
          error = true;
          if (this.showSymbols) {
            this.error.push(this.cards[i]);
          }
          if (this.showHelptext) {
            if (this.solution[i] > this.count[this.cards[i]]) {
              this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
            } else {
              this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
            }
          }
        }
      }
      if (error) {
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
      } else {
        this.solved = true;
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      }
    }
  }

  /** when a card is place in the bucket, we need to perform some actions */
  addCardToBucket(card) {
    if (this.buckets[card] == this.size[card]) {
      this.messageService.addAlertWithTimeout(this.get("erroraddCardToBucket"), "danger", 3000);
      return;
    }
    this.count[card]--;
    this.buckets[card]++;

  }

  /** transform full bucket */
  transformBucket(card: number) {
    if (this.buckets[card] < this.size[card]) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransform"), "danger", 3000);

      return;
    }
    this.buckets[card] = 0;
    this.count[this.cards[this.cards.indexOf(card) - 1]] += 1;
  }

  /** transform full bucket */
  transformCards(card: number) {
    if (this.buckets[card] > this.count[card]) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransformNotEnoughCards"), "danger", 3000);
      return;
    }
    if (this.buckets[card] < this.size[card]) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransform"), "danger", 3000);
      return;
    }
    if (this.buckets[card] % this.size[card] != 0) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransformWrongNumber"), "danger", 3000);
      return;
    }

    this.count[this.cards[this.cards.indexOf(card) - 1]] += this.buckets[card] / this.size[card];
    this.count[card] -= this.buckets[card];
    this.buckets[card] = 0;
  }

  /** empty bucket again */
  emptyBucket(card) {
    this.count[card] += this.buckets[card];
    this.buckets[card] = 0;
  }

  /* changes to make, when the count of a card changes by construting a reduction exercise*/
  changeValue() {
    if (this.exerciseType == 'reduction') {
      this.solution = this.numberCardsService.getSolution(this.numberCardsService.getValue(this.count), this.cards);
    }
  }

  /* returns the description for the choosen exercisetype*/
  getDescription(): string {
    switch (this.exerciseType) {
      case 'reduction': return this.get("cardRepresentationReductionDescription");
      case 'numberCard': return this.get("cardRepresentationDescription");
      case 'position': return this.get("positionRepresentationDescription");
      case 'addition': return this.isMultiplication ? this.get("cardRepresentationMultiplicationDescription") : this.get("cardRepresentationAdditionDescription");
    }
  }

  /** adds a card of the given value for A
   * @param {number} card - value of card to add
  */
  addedCardb(card: number): void {
    this.countB[card]++;
  }

  /** removes a card of the given value for A
   * @param {number} card - value of card to remove
  */
  removeCardb(card: number): void {
    this.countB[card]--;
  }

  /** adds the numbers if possible */
  addNow() {
    if (!this.checkSolutionInd(this.count, this.solutionA)) {
      return;
    }
    if (!this.checkSolutionInd(this.countB, this.solutionB)) {
      return;
    }

    for (let index in this.count) {
      this.count[index] += this.countB[index];
      this.buckets[index] = 0;
      this.countB[index] = 0;
    }
    this.solution = this.numberCardsService.getSolution(this.numberCardsService.getValue(this.count), this.cards);
    this.added = true;
  }

  /** multiplies the numbers if possible */
  multiplyNow() {
    if (!this.checkSolutionInd(this.count, this.solutionA)) {
      return;
    }

    for (let index in this.count) {
      this.count[index] *= this.givenNumbers.length;
      this.buckets[index] = 0;
    }
    this.solution = this.numberCardsService.getSolution(this.numberCardsService.getValue(this.count), this.cards);
    this.added = true;
  }

  /** checks individual Solutions */
  checkSolutionInd(count: number[], solution: number[]): boolean {
    let error = false;
    this.error = [];
    this.feedback = "";
    let value = this.numberCardsService.getValue(count)
    if (value != this.numberCardsService.getValue(solution) && this.showHelptext) {
      this.feedback = this.get("hasValue").concat(value.toString(), ". ");
    }
    for (let i = 0; i < this.cards.length; i++) {
      if (solution[i] != count[this.cards[i]]) {
        error = true;
        if (this.showSymbols) {
          if (solution == this.solutionB) {
            this.errorb.push(this.cards[i]);
          } else {
            this.error.push(this.cards[i]);
          }
        }
        if (this.showHelptext) {
          if (solution[i] > count[this.cards[i]]) {
            this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
          } else {
            this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
          }
        }
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
      return false;
    } else {
      return true;
    }
  }

  /** sets the counts correctly  */
  onChangeGivenNumbers() {
    if (this.representationDefined()) {
      let solution = this.numberCardsService.getSolution(this.givenNumbers[0], this.cards);
      let index = 0;
      this.solutionA = this.numberCardsService.getSolution(this.givenNumbers[0], this.cards);
      if (!this.isMultiplication) {
        this.solutionB = this.numberCardsService.getSolution(this.givenNumbers[1], this.cards);
      }
    }
  }
  /** returns the value of the current representation */
  valuePosition() {
    return this.numberCardsService.getValue(this.count);
  }

  /** returns the remainder of the current positionRepresentation */
  remainder() {
    return this.requestedNumber - this.valuePosition();
  }

  maxNumber():number{
    if(this.representationDefined()){
    switch (this.representation) {
      case "nary": return this.cards[0] * this.representationSpec; 
      case "roman": return 1000;
      case "etruscan": return 36000;
      case "hexadecimal": return 4096;
      case "personal": return this.cards[0] * 10;
    }
  } else {
    return 100000;
  }
  }
  getMax(card:number):number{
    let value = this.numberCardsService.getValue(this.count);
    value = value - card * this.count[card];
    let result = Math.floor((this.maxNumber() - value-1) / card);
    return result;
  }
  
  floor(card){
    this.count[card] = Math.floor(this.count[card]);
  }
}


